import * as colorsDark from "../../tokens/js/dark";

export default colorsDark;